import request from "@/utils/request";

export default function agentDelCarport(id) {
    return request.post(`/device/carport/agentDelCarport/${id}`)
}
